import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './Info.css';
import SectionTitle from './SectionTitle';
import logo from '../assets/hilal-makine.png'; // Logo import

function Info() {
  return (
    <Container className="my-5" id="info">
      <SectionTitle text="HAKKIMIZDA" />
      <Row className="align-items-center mt-4">
        <Col md={6} className="info-text">
          <p>
            Hilal Teknik, sektörde uzun yıllardır edindiği tecrübe ile müşterilerine kaliteli, güvenilir ve
            profesyonel hizmet sunmaktadır. Atölyemiz modern ekipmanları ve uzman ekibiyle her projeyi
            titizlikle yürütmektedir.
          </p>
          <p>
            Müşteri memnuniyetini önceliğimiz olarak görüyor ve sürekli olarak kendimizi geliştiriyoruz.
            Hizmetlerimiz ve projelerimiz hakkında daha fazla bilgi almak için bizimle iletişime geçebilirsiniz.
          </p>
          <Button 
            variant="warning" 
            className="mt-3" 
            onClick={() => {
              const section = document.getElementById('contact');
              if (section) {
                const yOffset = -200;
                const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({ top: y, behavior: 'smooth' });
              }
            }}
          >
            İletişime Geç
          </Button>
        </Col>
        <Col md={6} className="info-image">
          <img 
            src={logo} 
            alt="Hakkımızda" 
            className="img-fluid logo-image" 
          />
        </Col>
      </Row>
    </Container>
  );
}

export default Info;
